export * from './angularfire2';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
